import React from 'react';

import useCreateFlowsModalController from './useCreateFlowsModalController';
import FlowRequestModal from '../../../../atomic/organism/FlowRequestModal';
import RequestTemplateModal from '../../../../atomic/organism/FlowRequestModal/RequestTemplateModal';
import { renderPreviewTemplateModal } from '../../utils';

type CreateFlowsModalControllerProps = {
  handleModalClose: () => void;
};

const CreateFlowsModalController = (props: CreateFlowsModalControllerProps) => {
  const { handleModalClose } = props;
  const {
    selectedCategory,
    handleCategoryClick,
    handleCategoryBlur,
    searchValue,
    setSearchValue,
    categories,
    isGetCategoriesLoading,
    isGetTemplatesLoading,
    handleTemplateClick,
    templates,
    handleRequestTemplateFromScratchClick,
    isRequestModalOpen,
    handleRequestTemplateModalClose,
    isCreateFlowsModalOpen,
    requestFoTemplate,
    renderPreviewTemplateModalProps,
  } = useCreateFlowsModalController({
    handleCreateFlowsModalClose: handleModalClose,
  });

  return (
    <>
      <FlowRequestModal
        value={searchValue}
        isOpen={isCreateFlowsModalOpen}
        handleClose={handleModalClose}
        categories={categories}
        onCategoryClick={handleCategoryClick}
        onCategoryBlur={handleCategoryBlur}
        selectedCategory={selectedCategory}
        templateCardItems={templates}
        onChange={setSearchValue}
        isGetCategoriesLoading={isGetCategoriesLoading}
        isGetTemplatesLoading={isGetTemplatesLoading}
        onTemplateClick={handleTemplateClick}
        onRequestTemplateFromScratchClick={
          handleRequestTemplateFromScratchClick
        }
      />
      {renderPreviewTemplateModal(renderPreviewTemplateModalProps)}
      <RequestTemplateModal
        isOpen={isRequestModalOpen}
        onModalClose={handleRequestTemplateModalClose}
        templateName={requestFoTemplate}
      />
    </>
  );
};

export default CreateFlowsModalController;
